import React, {FunctionComponent, useContext} from 'react';

import {PageContext, PageContextProps} from "/src/contexts/Page";
import {User} from "/src/domain/shared/User";

import {Header} from "/src/ui/shared/header";
import {Footer} from "/src/ui/shared/footer";
import {ThemeProvider, StyledEngineProvider, GlobalStyles} from '@mui/material';
import {makeStyles, ThemeProvider as ThemeProviderForStyles} from '@mui/styles';
import theme from '/src/ui/shared/styledTheme'
import { theme as themeColor } from '/src/assets/theme';

import {ChallengeClubRatingData} from "/src/domain/challenges/ChallengeClubRatingData";
import RatingHeader from "/src/ui/challengeClubRating/RatingHeader";
import RatingParticipants from "/src/ui/challengeClubRating/RatingParticipants";


const ChallengeClubRatingApp: FunctionComponent = () => {
    const {pageData, currentUser} = useContext(PageContext) as PageContextProps;

    if (pageData === null) return null;

    const challengeRating = pageData as ChallengeClubRatingData;
    return <StyledEngineProvider injectFirst>
        <GlobalStyles
            styles={{
                'body': {
                    backgroundColor: themeColor.WHITE_COLOR,
                },
            }}
        />
        <ThemeProvider theme={theme}>
            <ThemeProviderForStyles theme={theme}>
                <App
                    challengeRating={challengeRating}
                    currentUser={currentUser}
                />
            </ThemeProviderForStyles>
        </ThemeProvider>
    </StyledEngineProvider>;
}

interface AppProps {
    challengeRating: ChallengeClubRatingData;
    currentUser?: User;
}

const App: FunctionComponent<AppProps> = ({
                                              challengeRating,
                                              currentUser
                                          }) => {
    const classes = useStyles()

    return <>
        <Header currentUser={currentUser}/>
        <div className={classes.contentContainer}>
            <RatingHeader
                club={challengeRating.club}
            />
            <RatingParticipants
                ratingParticipants={challengeRating.ratingClub}
                currentUserId={currentUser?.id}
            />
        </div>
        <Footer/>
    </>;
}

const useStyles = makeStyles((theme) => ({
    contentContainer: {
        [theme.breakpoints.up("sm")]: {
            maxWidth: "1100px",
            margin: "0 auto",
            minHeight: "calc(100vh - 20rem)",
        },
        minHeight: "calc(100vh - 23rem)",
    }
}))

export default ChallengeClubRatingApp